/**
 * Allows intellisense while typing a string identifier in VS Code.
 */
export enum strings {
  ANONYMOUS = "Anonymous",
  BACK_BUTTON = "Back",
  CANCEL_BUTTON = "Cancel",
  CLEAR_BUTTON = "Clear",
  FIND_BUTTON = "Find",
  NEXT_BUTTON = "Next",
  OK_BUTTON = "Ok",
  PREVIOUS_BUTTON = "Previous",
  SAVE_BUTTON = "Save",
  BRAND_NAME = "Placyy",
  CHATBOT_TITLE = "Miranda Virtual Assistant",
  ERROR_PAGE_NOT_FOUND_TITLE = "There`s nothing here...",
  ERROR_PAGE_NOT_FOUND_SUBTITLE = "...maybe the page you`re looking for is not found or never existed.",
  ERROR_PAGE_NOT_FOUND_BUTTON = "Back to home",
  ADD_VACANCY_PAGE_CREATE_VACANCY = "Create vacancy",
  ADD_VACANCY_PAGE_EDIT_VACANCY = "Edit vacancy",
  ADD_VACANCY_STEP_ONE_DESCRIPTION = "Companies that provide information about their competence - find the candidates faster.",
  ADD_VACANCY_STEP_ONE_CONTINUE = "Continue",
  ADD_VACANCY_STEP_ONE_ORGANISATION_NAME = "Company name",
  ADD_VACANCY_STEP_ONE_ORGANISATION_DESCRIPTION = "Company information",
  ADD_VACANCY_STEP_ONE_ORGANISATION_WEBSITE_URL = "Website",
  ADD_VACANCY_STEP_TWO_CREATE = "Create",
  ADD_VACANCY_STEP_TWO_UPDATE = "Update",
  ADD_VACANCY_STEP_TWO_JOB_TITLE = "Position",
  ADD_VACANCY_STEP_TWO_JOB_DESCRIPTION = "Describe the vacancy",
  ADD_VACANCY_STEP_TWO_JOB_LOCATION = "Job location",
  ERROR_TEXT_REQUIRED = "The field is required",
  ERROR_TEXT_SPECIAL_SYMBOLS = "Invalid data",
  ERROR_TEXT_WEBSITE_URL = "Invalid domain",
  ERROR_TEXT_EMAIL = "Email is invalid",
  ERROR_TEXT_DATE = "Date format is incorrect (dd.mm.yyyy)",
  ERROR_CONFIGURATION_QUERY_COLUMN_MISSING = `Oh no! Something's not quite right with the system. We're missing some query columns in the configuration, which is causing the issue. Please get in touch with our friendly support team, and they'll help you resolve this in a jiffy. In the meantime, feel free to select a different menu option or try again later. Thanks for your patience!`,
  ERROR_CONFIGURATION_QUERY_ERROR = `Uh-oh! There seems to be an issue with the system. There's a configuration element that's amiss, leading to the problem. Please reach out to our helpful support team, and they'll assist you in quickly resolving this. Meanwhile, you're welcome to choose an alternative menu choice or attempt again later. We appreciate your understanding!`,
  ERROR_DB_UPDATE_FAILURE = "Database Update Failed. Please try again later or contact support",
  FIND_VACANCY_PLACEHOLDER_VACANCIES_SEARCH = "Find vacancy",
  FIND_VACANCY_CHAT_TAB = "Chat",
  FING_VACANCY_MAIN_TAB = "Main",
  FIND_VACANCY_PROFILE_TAB = "Profile",
  POPUP_VACANCY_CREATED_CREATED = "The vacancy has been successfully created",
  POPUP_VACANCY_CREATED_UPDATED = "The vacancy has been successfully updated",
  POPUP_VACANCY_CREATED_TO_MAIN = "To main",
  POPUP_VACANCY_CREATED_CREATE_ONE_MORE = "Create one more vacancy",
  VACANCIES_PAGE_VACANCIES = "Vacancies",
  VACANCIES_PAGE_COMPLETED_VACANCIES = "Completed",
  VACANCIES_PAGE_EDIT = "Edit",
  USER_PAGE_FORM_TITLE = "Personal data",
  USER_PAGE_NAME_FIELD = "First name",
  USER_PAGE_MIDDLE_NAME_FIELD = "Middle name",
  USER_PAGE_FAMILY_NAME_FIELD = "Last name",
  USER_PAGE_BIRTH_DATE_FIELD = "Date of birth",
  USER_PAGE_GENDER_CODE_FIELD = "Gender",
  USER_PAGE_JOB_TITLE_FIELD = "Occupation",
  USER_PAGE_DESCRIPTION_FIELD = "About me",
  USER_PAGE_EMAIL_ADDRESS_FIELD = "Email address",
  USER_PAGE_FAX_FIELD = "Fax number",
  USER_PAGE_MOBILE_PHONE_FIELD = "Mobile phone number",
  USER_PAGE_TELEPHONE1_FIELD = "Phone number 1",
  USER_PAGE_TELEPHONE2_FIELD = "Phone number 2",
  USER_PAGE_TELEPHONE3_FIELD = "Phone number 3",
  USER_PAGE_WEBSITE_URL_FIELD = "Website url",
  USER_PAGE_BIRTH_FORMAT = "dd.mm.yyyy",
  USER_PAGE_EDIT_THE_FIELD = "Edit the field",
  SIDE_MENU_THEME = "Dark theme",
  WITH_RETRY_WENT_WRONG = "Something went wrong",
  WITH_RETRY_TRY_AGAIN = "Please try again or refresh the page.",
  WITH_RETRY_BUTTON = "Retry",

  CHAT_MESSAGE = "Message",
  CHAT_SEND = "Send",
  CHAT_CHATS = "Chats",
  CHAT_YESTERDAY = "Yesterday",
  CHAT_TODAY = "Today",
  CHAT_MY_CHATS = "My chats",
  FLOATING_MARKER_SELECT = "Select",
  MAP_SEARCH_HERE = "Search here",
  EMPTY_VACANCY_LIST = "It looks like there are no job listings that match your search criteria. Try different search parameters to see if you can find any suitable job openings.",
  EMPTY_CHAT_LIST = "Upload your documents and start the conversation!",
  SELECT_CHAT = "No message selected",
  EMPTY_LIST_PARAGRAPH_1 = "It looks like you`ve found a job that doesn`t exist there yet. Don`t worry though, everything is still AWESOME.",
  EMPTY_LIST_PARAGRAPH_2 = "Here are some options:",
  EMPTY_LIST_PARAGRAPH_3 = "You can try a search in a slightly different area, that should turn up the jobs you were looking for.",
  EMPTY_LIST_PARAGRAPH_4 = "Your may want to try a different job title and please avoid using abbreviations.",
  EMPTY_LIST_PARAGRAPH_5 = `I want to recieve the latest job alerts arount me.`,
  EMPTY_LIST_INPUT_EMAIL = "Type in your email",
  EMPTY_LIST_SUBSCRIBE = "Subscribe",
  //amplify
  LOGIN_FAMILY_NAME = "Family name:",
  LOGIN_NAME = "Name:",
  LOGIN_ENTER_NAME = "Enter your name",
  LOGIN_EMAIL = "Email:",
  LOGIN_PASSWORD = "Password:",
  LOGIN_CONFIRM_PASSWORD = "Confirm password",
  LOGIN_CONFIRMATION_CODE = 'Confirmation code',
  LOGIN_TERMS_CONDITIONS_CHECKBOX = "I agree with the Terms & Conditions",
  LOGIN_TERMS_CONDITIONS = "You must agree to the Terms & Conditions",
  LOGIN_RIGHTS_RESERVED = "All Rights Reserved",
  LOGIN_FORGOT_PASSWORD = "Forgot password?",
  LOGIN_RESET_PASSWORD_HEADING = "Reset Password",
  LOGIN_CREATE_NEW_PASSWORD_HEADING = 'Create new password',
  LOGIN_NEW_PASSWORD = "New password",
  LOGIN_ORGANISATION_LABEL = "Organisation name",
  LOGIN_ORGANISATION_PLACEHOLDER = "Enter organisation name",
  LOGIN_CRN_LABEL = "Company Registration Number (CRN)",
  LOGIN_CRN_PLACEHOLDER = "Enter CRN",
  CONTACT_GIVEN_NAME_MIN_LENGTH_ERROR = "Name should be at least 2 characters long",
  CONTACT_GIVEN_NAME_MAX_LENGTH_ERROR = "Name is too long. Please limit the input to 50 characters or fewer",
  CONTACT_GIVEN_NAME_IS_REQUIRED_ERROR = "Please enter the given name",
  CONTACT_GIVEN_NAME_PATTERN_ERROR = "Please use letters only",
  CONTACT_BIRTH_DATE_MIN_LENGTH_ERROR = "Please enter a valid birth date",
  CONTACT_PHOTO_MAX_ERROR = "File too large, please select an image less than 15Kb",
}
